module.exports = __webpack_public_path__ + "static/media/BITACore_Top_Logo-Background.c0942350.svg";